import { render, staticRenderFns } from "./PageSelect.vue?vue&type=template&id=720c58b6&scoped=true&"
import script from "./PageSelect.vue?vue&type=script&lang=js&"
export * from "./PageSelect.vue?vue&type=script&lang=js&"
import style0 from "./PageSelect.vue?vue&type=style&index=0&id=720c58b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c58b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
